import { useContext } from "react";
import { AppContext } from "../../App";
import img from "../../images/promo-code.png";
import Label from "../Label";
import "./style.css";
import { useAppStore } from "../../useAppStore";

export default function PromoBanner({ customClass = "" }) {
  const { settings } = useContext(AppContext);
  const { setPromoPopupVisible } = useAppStore();

  const promoEnabled =
    settings?.mandant?.discounts == 1 || settings?.fidelity?.active == 1 || settings?.credit?.active == 1;

  if (!promoEnabled) return null;

  return (
    <>
      <div className={"promo-banner " + customClass}>
        <div className="img">
          <img src={img} alt="Promo Banner" />
        </div>
        <div className="text">
          <Label number={216} />
        </div>
        <button onClick={() => setPromoPopupVisible(true)}>
          <Label number={217} />
        </button>
      </div>
    </>
  );
}
